import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { addOccurrence } from './add-occurrence.js'
import { collectLocalListNameErrors } from './collect-local-list-name-errors.js'
import { getTabFields } from './get-tab-fields.js'
import { isPersistedSchemaField } from './is-persisted-schema-field.js'

export function collectSchemaPersistedNames(
  fields: SchemaField[],
  pathPrefix: string,
  occurrences: Map<string, string[]>,
  errors: string[]
): void {
  for (const field of fields) {
    const fieldPath = `${pathPrefix}.${field.name || field.type}`
    if (field.name && isPersistedSchemaField(field)) {
      addOccurrence(occurrences, field.name, fieldPath)
    }

    if ((field.type === 'group' || field.type === 'section') && field.fields) {
      collectSchemaPersistedNames(field.fields, fieldPath, occurrences, errors)
    }

    if (field.type === 'tabs' && field.tabs) {
      for (const tab of field.tabs) {
        collectSchemaPersistedNames(
          getTabFields(tab),
          `${fieldPath}.tabs.${tab.name}`,
          occurrences,
          errors
        )
      }
    }

    if (field.type === 'list' && field.fields) {
      collectLocalListNameErrors(field.fields, `${fieldPath}.fields`, errors)
    }
  }
}
